import type { OnboardingHoldoutState } from './constants';

export const DEFAULT_HOLDOUT_STATE: OnboardingHoldoutState = {
	lastSeenAt: 0,
	exposureCount: 0,
	onboardingCompleted: false,
};
